import { SET_VIDEOS, SELECT_VIDEO, ADD_VIDEO } from "./actionTypes";

interface VideoState {
  list: unknown[];
  selected: number | null;
}

interface VideoAction {
  type: string;
  payload?: unknown;
}

const initialState: VideoState = {
  list: [],
  selected: null,
};

const videoReducer = (state = initialState, action: VideoAction): VideoState => {
  switch (action.type) {
    case SET_VIDEOS:
      return { ...state, list: action.payload as unknown[] };
    case SELECT_VIDEO:
      return { ...state, selected: action.payload as number };
    case ADD_VIDEO:
      return { ...state, list: [...state.list, action.payload] };
    default:
      return state;
  }
};

export default videoReducer;
